export default __webpack_public_path__ + "static/media/tartaletas-chocolate.228aa26e.jpg";